import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import Title from "./Title";

interface AppPageHeaderProps {
    title: string;
    description?: string;
    actions?: ReactNode;
    className?: string;
    actionsClassName?: string;
}

export function AppPageHeader({ title, description, actions, className, actionsClassName }: AppPageHeaderProps) {
    return (
        <div
            className={cn(
                "flex md:flex-row flex-col md:justify-between items-stretch md:items-start gap-4 w-full min-w-0",
                className
            )}
        >
            <div className="flex-1 [&>div]:mb-0 min-w-0">
                <Title words={title} description={description} />
            </div>
            {actions ? (
                <div
                    className={cn(
                        "hidden md:flex flex-wrap justify-end items-center gap-2 md:pt-1 shrink-0",
                        actionsClassName
                    )}
                >
                    {actions}
                </div>
            ) : null}
        </div>
    );
}
